
import SvgIcon from '@material-ui/core/SvgIcon';

export default function Close(props) {
	return(
		<SvgIcon {...props}>
			<path d="M10 8.586l-7.071-7.071-1.414 1.414 7.071 7.071-7.071 7.071 1.414 1.414 7.071-7.071 7.071 7.071 1.414-1.414-7.071-7.071 7.071-7.071-1.414-1.414-7.071 7.071z"></path>
		</SvgIcon>
	);
}